import { createFileRoute, useSearch } from '@tanstack/react-router';
import { z } from 'zod';
import { HistoryFeed } from '@/app/(client)/supply-chain-mapping/-components/HistoryFeed';
import { useAllSupplyChains } from '@/app/(client)/supply-chain-mapping/-hooks/useAllSupplyChains';
import { useHistoryTab } from '@/app/(client)/supply-chain-mapping/-hooks/useHistoryTab';
import { useSheet } from '@/hooks/useSheet';

const historySearch = z.object({
  collaborationId: z.string().optional(),
});

export const Route = createFileRoute(
  '/(client)/supply-chain-mapping/(pages)/(list)/history/',
)({
  validateSearch: historySearch,
  component: HistoryPage,
});

function HistoryPage() {
  const search = useSearch({
    from: '/(client)/supply-chain-mapping/(pages)/(list)/history/',
  });
  const collaborationSheet = useSheet({ param: 'collaborationId' });

  const collaborationId = search.collaborationId;

  const { data: scData } = useAllSupplyChains();
  const { data, isFetchingNextPage, hasNextPage, fetchNextPage, isLoading } =
    useHistoryTab(collaborationId);

  const entries = data?.pages.flatMap(p => p.data ?? []) ?? [];

  const setCollaborationId = (id: string) => {
    if (id) collaborationSheet.onOpen(id);
    else collaborationSheet.onClose();
  };

  return (
    <div className='flex flex-col flex-1 min-h-0 overflow-y-auto'>
      <HistoryFeed
        entries={entries}
        hasNextPage={!!hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        isLoading={isLoading}
        onLoadMore={() => void fetchNextPage()}
        supplyChains={scData?.data ?? []}
        collaborationId={collaborationId ?? ''}
        onCollaborationChange={setCollaborationId}
      />
    </div>
  );
}
